import {
    ApplianceModel,
    ChipMinimizerModel,
    ColorModel,
    CornerRadiusModel,
    CutoutLaborModel,
    CutoutModel,
    DiagonalCornerModel,
    EdgeModel,
    JointPoint,
    OptionalProduct,
    PlumbingProduct,
    PricedProduct,
    ProductDetails,
    TearOutModel,
    WaterfallLabor,
} from '@common/models';

// I'm leaving this here initially because I'm not convinced of the future of it as is
// and this is the only use we have for it to date
export type Product =
    | OptionalProduct
    | ApplianceModel
    | ChipMinimizerModel
    | ColorModel
    | CornerRadiusModel
    | CutoutModel
    | DiagonalCornerModel
    | EdgeModel
    | TearOutModel
    | WaterfallLabor // this doesn't have consumerDesc but probably should for consistency
    | CutoutLaborModel
    | PricedProduct
    | JointPoint
    | PlumbingProduct
    | ProductDetails;

const emptyName = ''; // this is gonna look bad if we ever see it, should not happen

export const getProductDescription = (
    product: Product,
    useAbbrev?: boolean // explicitly try to use abbreviated description first
): string => {
    const abbrev = useAbbrev && product.abbrevDesc?.length ? product.abbrevDesc : null;
    const consumer = product.consumerDesc?.length ? product.consumerDesc : null;
    const name = product.name?.length ? product.name : null;

    return abbrev ?? consumer ?? name ?? emptyName;
};
